import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-scroll'
import LoginRoute from '../LoginRoute/LoginRoute';
import Logo from '../../Assets/logo.png';

const Navbar = () => {
    const [Navbar, setNavbar] = useState(false);
    const [menu, setmenu] = useState(false);


    const ChangeNav = () => {
        if (window.scrollY >= 120) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }
    window.addEventListener('scroll', ChangeNav)

    return (
        <div className="navbar-wrapper">
            <div className="navbar-top-wrapper">
                <div className="navbar-top">
                    <p>
                        If you have any questions or want to know more about our product, schedule a free call with us now!
                    </p>
                    <button className='btn'>Book A Discovery Call</button>
                </div>

                <div className={"navbar-bottom-wrapper " + (Navbar ? 'navbar-fixed' : '')}>
                    <div className="navbar-bottom">
                        <div className="navbar-logo">
                            <img src={Logo} alt="" />
                        </div>
                        <div className={"navbar-menu " + (menu ? 'navbar-menuActive' : '')}>
                            <ul>
                                <Link to='home' smooth={true} spy={true} activeClass='active' ><li>Home</li></Link>
                                <Link to='work' smooth={true} spy={true} activeClass='active' ><li>How it Work</li></Link>
                                <Link to='mentor' smooth={true} spy={true} activeClass='active' ><li>Mentors</li></Link>
                                <Link to='book' smooth={true} spy={true} activeClass='active' ><li>Book Class</li></Link>
                                <Link to='about' smooth={true} spy={true} activeClass='active' ><li>About Us</li></Link>
                                <Link to='contact' smooth={true} spy={true} activeClass='active' ><li>Contact Us</li></Link>
                            </ul>
                            <LoginRoute />
                            <div className={"hanburgurmenu " + (menu ? 'menuActive' : '')} onClick={() => setmenu(!menu)}>
                                <div className="line"></div>
                                <div className="line"></div>
                                <div className="line"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar

// 3:36